<template>
  <v-card class="pa-1 rounded-lg">
    <v-card-text class="white">
      <v-card class="mb-7" color="comment" rounded="lg" outlined flat>
        <v-card-title>
          <v-spacer></v-spacer>

          <v-btn
            v-if="$store.getters['rolesUser/getCustomRole'](186)"
            @click="saveClientsAllocation"
            class="btn-save"
            dark
            small
          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>

      <AccountingAssign
        v-if="$store.getters['rolesUser/getCustomRole'](184)"
        v-model="form.id_account"
        :win="win"
        :assignAll="true"
        @accountChanged="accountChanged"
        @assignAllAccounts="assignAllAccounts"
      >
      </AccountingAssign>
      <v-col cols="12">
        <v-radio-group v-model="changueAll" row >
            <v-radio label="Asignar Cuenta de Cuentas por Cobrar" value="CuentaCuentasPorCobrar"></v-radio>
            <v-radio label="Asignar Cuenta de Cuentas por Pagar" value="CuentaCuentasPorPagar"></v-radio>
            <v-radio label="Asignar Cuenta de Costos" value="CuentaCostos"></v-radio>
            <v-radio label="Asignar Cuenta de Gastos" value="CuentaGastos"></v-radio>
            <v-radio label="Asignar Cuenta de Bancos" value="CuentaBanco"></v-radio>
        </v-radio-group>
      </v-col>

      <!-- Filtro por tipo de cliente -->
      <v-card class="mb-4" outlined>
        <v-card-title class="py-2">
          <v-icon class="mr-2">mdi-filter</v-icon>
          Filtrar por tipo de cliente
        </v-card-title>
        <v-card-text class="py-2">
          <v-radio-group
            v-model="clientTypeFilter"
            row
            @change="applyClientTypeFilter"
          >
            <v-radio
              v-for="option in clientTypeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
              class="mr-4"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-card>

      <VersatileFilter
        entity="lista"
        :filterEndpoint="$API.customers.getCustomersFilteredWithAccounts"
        :search="search"
        @emptyFilter="getAllClients"
        @filtered="filterHandlerClients"
        :columnfilterEndpoint="
          $API.customers.getCustomersFilteredColumnWithAccounts
        "
        :columnsSearch="columsConfig"
        :disableDates="true"
        advanced-filter
        v-if="$store.getters['rolesUser/getCustomRole'](178)"
      >
        <DxDataGrid
          ref="accountClients"
          :data-source="clients"
          key-expr="ID_Customer"
          :show-row-lines="showRowLines"
          @exporting="onExporting"
          :show-borders="showBorders"
          :row-alternation-enabled="rowAlternationEnabled"
          @editing-start="onEditingStart"
          :scrolling="{ useNative: true }"
          :column-auto-width="true"
          @row-updating="validateData"
        >
          <DxExport :enabled="$store.getters['rolesUser/getCustomRole'](187)" />
          <DxEditing :allow-updating="true" mode="cell" />
          <DxPaging :page-size="10" />
          <DxColumn
            data-field="ID_Customer"
            caption="ID"
            :allow-updating="false"
          ></DxColumn>

          <!-- <DxColumn
            data-field="customerNameToShow"
            caption="Nombre del Cliente"
            :allow-updating="false"
          ></DxColumn>
          <DxColumn
            data-field="customerEmailToShow"
            caption="Email del Cliente"
            :allow-updating="false"
          ></DxColumn> -->

          <DxColumn cell-template="show-template-name" caption="Nombre del Cliente"></DxColumn>

          <!-- <DxColumn data-field="customerEmailToShow" caption="Correo "></DxColumn>  -->
          <DxColumn cell-template="show-template-email" caption="Email del Cliente"></DxColumn>

          <DxColumn caption="Clase" cell-template="show-template-class"></DxColumn> 
          <DxColumn caption="Categoría" cell-template="show-template-category"></DxColumn> 
          <DxColumn caption="Subcategoría" cell-template="show-template-subcategory"></DxColumn>

          <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaCuentasPorCobrar"
            :allow-updating="true"
            caption="Cuenta de Cuentas por Cobrar"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-templateCuentaCuentasPorPagar" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaCuentasPorPagar"
            :allow-updating="true"
            caption="Cuenta de Cuentas por Pagar"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-templateCuentaCostos" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaCostos"
            :allow-updating="true"
            caption="Cuenta de Costos"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-templateCuentaGastos" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaGastos"
            :allow-updating="true"
            caption="Cuenta de Gastos"
          ></DxColumn>
          <DxColumn :width="80" cell-template="show-templateCuentaBanco" caption=""></DxColumn>
          <DxColumn
            data-field="CuentaBanco"
            :allow-updating="true"
            caption="Cuenta de Bancos"
          ></DxColumn>

          <template #show-template-class="{ data }">
            <div>{{ showClass(data.data.id_class) }}</div>
          </template>
          <template #show-template-category="{ data }">
            <div>{{ showCategories(data.data.id_category) }}</div>
          </template>
          <template #show-template-subcategory="{ data }">
            <div>{{ showSubs(data.data.id_subcategory) }}</div>
          </template>
          <template #show-template-name="{ data }">
            <p v-if="data.data.Is_a_Business || data.data.Is_a_Ong  || data.data.Is_a_PublicEntity">
              {{ data.data.BusinessName }}
            </p>
            <p v-else>
              {{ data.data.FirstName }} {{ data.data.LastName }}
            </p>
          </template>
          <template #show-template-email="{ data }">
            <p v-if="data.data.Is_a_Business || data.data.Is_a_Ong  || data.data.Is_a_PublicEntity">
              {{ data.data.BusinessEmail }}
            </p>
            <p v-else>
              {{ data.data.Email }}
            </p>
          </template>
          <template #show-template="{ data }">
            <div>
              <a href="#" class="mx-1" @click="clientsSelected = data; showModel =true; assignOne = 'CuentaCuentasPorCobrar'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-templateCuentaCuentasPorPagar="{ data }">
            <div>
              <a href="#" class="mx-1" @click="clientsSelected = data; showModel =true; assignOne = 'CuentaCuentasPorPagar'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-templateCuentaCostos="{ data }">
            <div>
              <a href="#" class="mx-1" @click="clientsSelected = data; showModel =true; assignOne = 'CuentaCostos'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-templateCuentaGastos="{ data }">
            <div>
              <a href="#" class="mx-1" @click="clientsSelected = data; showModel =true; assignOne = 'CuentaGastos'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
          <template #show-templateCuentaBanco="{ data }">
            <div>
              <a href="#" class="mx-1" @click="clientsSelected = data; showModel =true; assignOne = 'CuentaBanco'">
                <v-icon>mdi-magnify

                </v-icon>
              </a>
            </div>
          </template>
        </DxDataGrid>
      </VersatileFilter>

      <v-dialog v-model="showModel" width="60%">
        <v-card>
          <AccountingItemForm
            :win="win"
            v-on:sendSelection="reactiveSelection"
          />
        </v-card>
      </v-dialog>

      <alert
        v-model="alert.show"
        :type="alert.type"
        :title="alert.header"
        :message="alert.body"
      ></alert>
    </v-card-text>
  </v-card>
</template>

<script>
import VersatileFilter from "@/components/VersatileFilter";
import AccountingItemForm from "./AccountingItemForm";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxExport,
  DxEditing,
} from "devextreme-vue/data-grid";
import AccountingAssign from "./AccountingAssign.vue";
import { mapMutations, mapState } from "vuex";
import { printToExcel } from "@/helpers/printToexcel";
export default {
  name: "AllocationClients",
  props: ["win", "datafilter"],
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    AccountingItemForm,
    DxExport,
    VersatileFilter,
    AccountingAssign,
  },

  data() {
    return {
      changueAll: 'CuentaCuentasPorCobrar',
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      assignOne: '',
      tab: null,
      panel: 0,
      form: {
        id_account: null
      },
      clientsSelected: false,
      clients: {},

      search: {
        filter: null,
      },
      clientTypeFilter: 'all', // Nuevo filtro para tipo de cliente
      clientTypeOptions: [
        { value: 'all', label: 'Todos' },
        { value: 'natural', label: 'Clientes Naturales' },
        { value: 'business', label: 'Negocios' },
        { value: 'ong', label: 'ONGs' },
        { value: 'public', label: 'Instituciones Públicas' }
      ],
      valid: null,
      editService: null,
      showModel: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      typebusiness: null,
      columsConfig: [
        {
          name: "ID_Customer",
          title: "Id de Cliente",
          value: "",
        }, 
        {
          name: "FirstName",
          title: "Nombre",
          value: "",
        },
        {
          name: "LastName",
          title: "Apellido",
          value: "",
        },
        {
          name: "id_class",
          title: "Clase",
          value: "",
          type: "select",
          options: [],
          onChange: this.getCategoriesByClass,
        },
        {
          name: "id_category",
          title: "Categoría",
          value: "",
          type: "select",
          options: [],
          onChange: this.getSubsByCategory,
          disabled: true,
        },
        {
          name: "id_subcategory",
          title: "Subategoría",
          value: "",
          type: "select",
          options: [],
          disabled: true,
        },
      ],

      filterServices: {},
      showOrderVacMed: false,
      optFilterOrder: 1,
      families: [],
      categories: [],
      subcategories: [],
      accountList: [],
      editableFieldsList: [
        "CuentaCuentasPorCobrar",
        "CuentaCuentasPorPagar",
        "CuentaCostos",
        "CuentaGastos",
        "CuentaBanco"
      ],
      columnLabels: {
        CuentaCuentasPorCobrar: "Cuenta de Cuentas por Cobrar",
        CuentaCuentasPorPagar: "Cuenta de Cuentas por Pagar",
        CuentaCostos: "Cuenta de Costos",
        CuentaGastos: "Cuenta de Gastos",
        CuentaBanco: "Cuenta de Bancos"
      },
    };
  },

  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    loading: {
      ...mapState({ get: "loading" }),
      ...mapMutations({ set: "loading" }),
    },
  },
  mounted() {
    this.$store.dispatch("rolesUser/getAllRoles");
    this.typebusiness =
      JSON.parse(localStorage.getItem("user")).businesstype || "";
    this.filterServices.business = JSON.parse(
      localStorage.getItem("user")
    ).businessid;
    this.filterServices.branch = JSON.parse(
      localStorage.getItem("user")
    ).branch;
    this.search.branch = this.filterServices.branch;
    this.search.business = this.filterServices.business;
    
    this.getAllClients();
    this.getFamilies();
    this.getCategories();
    this.getSubs();

    this.getClasses();
    this.getCategoriesClients();
    this.getSubsClients();
  },
  methods: {
    // isCustomerProvider( e ) {
    //   return e.row.data.
    // },
    accountChanged( e ) {
      this.form.id_account = e
    },
    applyClientTypeFilter() {
      // Aplicar filtro según el tipo de cliente seleccionado
      // Como el backend no soporta estos filtros, aplicamos filtrado del lado del cliente
      this.getAllClients();
    },
    applyClientTypeFilterToData(data) {
      // Aplicar filtro de tipo de cliente a los datos recibidos
      if (this.clientTypeFilter === 'all') {
        return data;
      }
      
      return data.filter(client => {
        switch (this.clientTypeFilter) {
          case 'natural':
            return !client.Is_a_Business && !client.Is_a_Ong && !client.Is_a_PublicEntity;
          case 'business':
            return client.Is_a_Business === 1;
          case 'ong':
            return client.Is_a_Ong === 1;
          case 'public':
            return client.Is_a_PublicEntity === 1;
          default:
            return true;
        }
      });
    },
    updateFilterServicesForClientType() {
      // Este método ya no es necesario para el filtrado del lado del cliente
      // Lo mantenemos por compatibilidad pero no hace nada
    },
    updateSearchParams() {
      // Este método ya no es necesario para el filtrado del lado del cliente
      // Lo mantenemos por compatibilidad pero no hace nada
    },
    reactiveSelection(data) {
      this.showModel = false;
      this.clientsSelected.data[ `new${ this.assignOne }` ] = data.id_account;
      this.clientsSelected.data[ this.assignOne ] = data.account_code;
      this.clientsSelected.data[ `new${ this.assignOne }Account_Code` ] = data.account_code;

      this.$refs.accountClients.instance.saveEditData();
    },
    getFamilies() {
      this.$API.itemtypes.getFamilies().then((response) => {
        this.families = response;
        this.families.forEach((family) => {
          this.columsConfig[4].options.push({
            name: family.name,
            value: family.id,
          });
        });
      });
    },
    getCategories() {
      this.$API.itemtypes.getCategories().then((response) => {
        this.categories = response;
        this.categories.forEach((category) => {
          this.columsConfig[5].options.push({
            name: category.name,
            value: category.id,
          });
        });
      });
    },
    validateData(e) {
      console.log(e);
      if (e.newData.account_code) {
        const found = this.accountList.find(
          (current) => current.account_code === e.newData.account_code
        );

        if (found) {
          e.newData.newId_account = found.id_account;
          e.newData.account_code = found.account_code;
        } else {
          e.cancel = true;
          this.showAlert("warning", "Error", "La cuenta ingresada no existe");
        }
      }
    },
    getSubs() {
      this.$API.itemtypes.getSubs().then((response) => {
        this.subcategories = response;
        this.subcategories.forEach((subcategory) => {
          this.columsConfig[6].options.push({
            name: subcategory.name,
            value: subcategory.id,
          });
        });
      });
    },
    assignAllAccounts() {
      const found = this.accountList.find(
        (current) => current.id_account === this.form.id_account
      );

      if (!found) {
        this.showAlert("warning", "Error", "Debe seleccionar una cuenta valida");
        return;
      }

      for (const index in this.clients) {
        this.clients[index][ `new${ this.changueAll }` ] = found.id_account;
        this.clients[index][ this.changueAll ] = found.account_code;
      }
      
      this.$refs.accountClients.instance.refresh();
      this.showAlert(
        "success",
        "Exito",
        `Se ha actualizado la tabla asignando la cuenta seleccionada a la columna "${this.getColumnLabel()}". Revise los cambios y haga click en el boton verde para guardar.`
      );
    },
    getAllAccounts(dataToFormat) {
      this.$API.branchaccountcatalog
        .getAssignableAccounts()
        .then((response) => {
          this.accountList = response.data;
          this.matchAccounts(dataToFormat);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    matchAccounts(dataToFormat) {
      // Aplicar filtro de tipo de cliente antes de procesar las cuentas
      const filteredData = this.applyClientTypeFilterToData(dataToFormat);
      
      for (const index in filteredData) {
        const { CuentaCuentasPorCobrar, CuentaCuentasPorPagar, CuentaCostos, CuentaGastos, CuentaBanco } = filteredData[index];

        const objThrough = {
          CuentaCuentasPorCobrar,
          CuentaCuentasPorPagar,
          CuentaCostos,
          CuentaGastos,
          CuentaBanco
        }

        for( const property in objThrough ) {
          if( objThrough[ property ] ) {
            const found = this.accountList.find(
              (current) => current.id_account === parseInt( objThrough[ property ] )
            );

            if (found) {
              filteredData[index][ property ] = found.account_code;
            }
          }
        }
      }

      this.clients = filteredData;
      this.$refs.accountClients.instance.saveEditData();
    },
    getColumnLabel() {
      return this.columnLabels[this.changueAll] || this.changueAll;
    },
    saveClientsAllocation() {
      try {
        this.loading = true;
        this.$refs.accountClients.instance.refresh();
        this.$API.branchaccountcatalog
          .assignAccountsCustomers([...this.clients])
          .then((response) => {
            this.showAlert("success", "Exito", response.msg);
            this.loading = false;
            this.getAllClients();
          })
          .catch((error) => {
            this.showAlert("error", "Error", error.message);
            this.loading = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
    onExporting(e) {
      printToExcel(e, "Clientes");
    },
    reload() {
      this.getAllClients();
      this.getClasses();
      this.getCategoriesClients();
      this.getSubsClients();
      setTimeout(() => {
        window.scrollTo(0, this.$store.getters.getScrollTop);
      }, 300);
    },
    showAlert(type, header, body) {
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
    },
    getAllClients() {
      this.filterServices.withInnerjoins = true;
      this.$API.customers
        .getCustomersFilteredColumnWithAccounts(this.filterServices)
        .then(async (response) => {
          await this.getAllAccounts(response);
        });
    },
    onEditingStart(e) {
      if (!this.editableFieldsList.includes(e.column.dataField)) {
        e.cancel = true;
      }
    },

    filterHandlerClients(response) {
      // Aplicar filtro de tipo de cliente a los datos filtrados
      const filteredData = this.applyClientTypeFilterToData(response);
      this.getAllAccounts(filteredData);
    },
    getClasses() {
      this.$API.customersTypes.getClasses().then((response) => {
        this.columsConfig[3].options = response.map(element => ({name: element.name, value: element.id}));
      });
    },
    getCategoriesClients() {
      this.$API.customersTypes.getCategories().then((response) => {
        this.columsConfig[4].options = response.map(element => ({name: element.name, value: element.id}));
        this.categoriesAll = response;
      });
    },
    getSubsClients() {
      this.$API.customersTypes.getSubs().then((response) => {
        this.columsConfig[5].options = response.map(element => ({name: element.name, value: element.id}));
        this.subcategoriesAll = response;
      });
    },
    getCategoriesByClass() {
      delete this.columsConfig[4].value;
      delete this.columsConfig[5].value;
      this.columsConfig[4].options = this.categoriesAll.filter(element => element.id_class === this.columsConfig[3].value).map(element => ({name: element.name, value: element.id}));
      this.columsConfig[4].disabled = false;
      this.columsConfig[5].disabled = true;
    },
    getSubsByCategory() {
      delete this.columsConfig[5].value;
      this.columsConfig[5].options = this.subcategoriesAll.filter(element => element.id_cat === this.columsConfig[4].value).map(element => ({name: element.name, value: element.id}));
      this.columsConfig[5].disabled = false;
    },
    showClass(idClass) {
      const classData = this.columsConfig[3].options.find(element => element.value === idClass);
      return classData?.name ?? '';
    },
    showCategories(idCategory) {
      const categoryData = this.columsConfig[4].options.find(element => element.value === idCategory);
      return categoryData?.name ?? '';
    },
    showSubs(idSubcategory) {
      const subcategoryData = this.columsConfig[5].options.find(element => element.value === idSubcategory);
      return subcategoryData?.name ?? '';
    },
  },
};
</script>
